module.exports = __webpack_public_path__ + "static/pays-78fbff0ad4a53001022e3a2040993383.svg";